export class GetLinkRegistryByIdError extends Error {
}